<template>
    <div>
        <div class="text-center">
            <h3>รายการเช็ค</h3>
            <b-row sm="10">
                <b-col sm="5" class="col text-right">
                    <label class="col-form-label">หมายเลขเช็ค</label>
                </b-col>
                <b-col sm="5">
                    <label class="col-form-label">
                        {{ form.ref_no }}
                    </label>
                </b-col>
            </b-row>
            <b-row sm="10">
                <b-col sm="5" class="col text-right">
                    <label class="col-form-label">วันที่เช็ค</label>
                </b-col>
                <b-col sm="5">
                    <label class="col-form-label">
                        {{ form.cheque_date | moment("DD/MM/YYYY") }}
                    </label>
                </b-col>
            </b-row>
            <b-row sm="10">
                <b-col sm="5" class="col text-right">
                    <label class="col-form-label">จำนวนเงิน</label>
                </b-col>
                <b-col sm="5">
                    <label class="col-form-label">
                        {{ form.amount | currency }}
                    </label>
                </b-col>
            </b-row>
            <b-row sm="10">
                <b-col sm="5" class="col text-right">
                    <label class="col-form-label">สถานะ</label>
                </b-col>
                <b-col sm="5">
                    <label class="col-form-label">
                        <input v-model="form.status"
                               type="radio"
                               name="status"
                               value="null"/>
                        &nbsp;รอการนำเข้า
                    </label>
                    <br/>
                    <label class="col-form-label">
                        <input v-model="form.status"
                               type="radio"
                               name="status"
                               value="1"/>
                        &nbsp;B
                    </label>
                    <label class="col-form-label" style="margin-left: 20px">
                        <input v-model="form.status"
                               type="radio"
                               name="status"
                               value="2"/>
                        &nbsp;P
                    </label>
                </b-col>
            </b-row>
            <b-row sm="10">
                <b-col sm="5" class="col text-right">
                    <label class="col-form-label">วันที่เช็คจ่าย (P)</label>
                </b-col>
                <b-col sm="5">
                    <date-picker
                        v-model="form.approve_date"
                        type="date"
                        :format="changeFormat"
                        :lang="lang"
                        confirm
                        placeholder="วันที่ใบรับเงิน">
                    </date-picker>&nbsp;&nbsp;
                </b-col>
            </b-row>
            <b-row sm="12">
                <b-col sm="5" class="col text-right">
                    <label class="col-form-label">บัญชีสำหรับนำเข้าเช็ค</label>
                </b-col>
                <b-col sm="6">
                    <multiselect
                        v-model="form.bankbook"
                        :options="optionBank"
                        :customLabel="customLabelBank"
                        :show-labels="false"
                        placeholder="เลขบัญชีธนาคาร"
                        track-by="id">
                    </multiselect>
                </b-col>
            </b-row>
            <br>
        </div>
        <div class="col text-center">
            <button @click="submitData"
                    type="button"
                    class="btn btn-success">
                <icon name="save" style="width: 25px"></icon>
                บันทึกและพิมพ์
            </button>
            &nbsp&nbsp
            <button @click="cancelData"
                    type="button"
                    class="btn btn btn-outline-secondary">
                <icon name="times" style="width: 25px"></icon>
                ยกเลิก
            </button>
        </div>
        <div style="display: none">{{ validateDate }}</div>
        <!--<pre class="alert alert-primary text-left">{{ form }}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import moment from "moment";
import Multiselect from "vue-multiselect"
import DatePicker from 'vue2-datepicker';

export default {
    name: "edit-cheque-modal",
    data() {
        return {
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    created() {
        this.$store.dispatch("Bank/getBankAll");
    },
    components: {
        Multiselect,
        DatePicker
    },
    computed: {
        ...mapState({
            ChequeList: state => {
                return state.ChequeListPayoff.ChequeList;
            },
            form: state => {
                return state.ChequeListPayoff.form;
            },
            optionBank: state => {
                return state.Bank.bank_all;
            }
        }),
        validateDate() {
            this.form.approve_date = moment(this.form.approve_date).format("YYYY-MM-DD");
            let date_year = moment(this.form.approve_date).format('YYYY'); //get year
            if (date_year <= 2000) {
                let current_year = moment().format("YYYY");
                this.form.approve_date = moment(this.form.approve_date).format(+current_year + "-MM-DD")
            }
        }
    },
    methods: {
        customLabelBank(option) {
            return `${option.account_number} - ${option.name}`
        },
        submitData() {
            if (this.form.bankbook) {
                this.form.bank_id = this.form.bankbook.id;
                this.$emit('submit', this.form);
            } else if (this.form.status == 1 && !this.form.bankbook) {
                alert("กรุณาเลือกบัญชีธนาคาร")
            } else if (this.form.status == 2 && !this.form.bankbook) {
                alert("กรุณาเลือกบัญชีธนาคาร")
            } else {
                if (this.form.status == 2 && !this.form.approve_date) {
                    this.form.approve_date = moment().format("YYYY-DD-MM");
                } else {
                    this.form.approve_date = moment(this.form.approve_date).format("YYYY-MM-DD");
                }
                this.$emit('submit', this.form);
            }
        },
        cancelData() {
            this.$emit('submit', 0);
        }
    }
}
</script>

<style scoped>

</style>
